import React from 'react';
import { TabContainer, TabList } from 'tuui';
import { HeaderCodeless } from '../components/Headers/HeaderCodeless';
import { ReviewEvents } from '../components/ReviewEvents/ReviewEvents';
import { StepNavigator } from './StepNavigator';
import styles from './viewcomponents.module.scss';

export const ViewTypes = {
    MAIN: 'main',
    REVIEW_EVENTS: 'reviewEvents',
};

export const getViewComponents = ({
    showTabNavigation,
    tabHeaders,
    tabContent,
    steps,
    currentStep,
    goNext,
    goBack,
    resetSteps,
    handleFinishSetup,
    handleGoBackToSetup,
    handleSetCurrentIndex,
    currentIndex,
    handleCloseFrame,
    handleNavigateMode,
    isNavigateMode,
    handleEditClick,
    setFocusedConversionId,
}) => ({
    main: () => (
        <>
            <div className={styles['header-container']}>
                {showTabNavigation && (
                    <HeaderCodeless
                        handleFinishSetup={handleFinishSetup}
                        handleNavigateMode={handleNavigateMode}
                        isNavigateMode={isNavigateMode}
                    />
                )}
                {!isNavigateMode && showTabNavigation && (
                    <TabContainer>
                        <TabList>{tabHeaders}</TabList>
                        <div className={styles['tab-content']}>{tabContent}</div>
                    </TabContainer>
                )}
            </div>
            {!isNavigateMode && !showTabNavigation && (
                <div>
                    <StepNavigator
                        steps={steps}
                        currentStep={currentStep}
                        goNext={goNext}
                        goBack={goBack}
                        resetSteps={resetSteps}
                        handleSetCurrentIndex={handleSetCurrentIndex}
                        currentIndex={currentIndex}
                        handleEditClick={handleEditClick}
                        setFocusedConversionId={setFocusedConversionId}
                    />
                </div>
            )}
        </>
    ),
    reviewEvents: () => (
        <ReviewEvents
            goBack={handleGoBackToSetup}
            onClose={handleCloseFrame}
            setFocusedConversionId={setFocusedConversionId}
        />
    ),
});
